import React from 'react'
import _ from 'lodash'
import { IMAGE_EDIT_MODAL } from '../../../constants/modalType'
import { getImageFile } from '../../../modules/portal-remote/portalImageService'
import withReduxModal, {
  modalPropTypes,
} from '../../../modules/redux-modal/redux/withReduxModal'
import PortalImageStoreModal from './PortalImageStoreModal'

class PortalImageStoreModalWithRedux extends React.Component {
  constructor(props) {
    super(props)
    this.handleClose = this.handleClose.bind(this)
  }

  async handleClose(params) {
    this.props.modalActions.hideModal()

    console.log('params', params, this.props.modal.openParams)

    if (params.imageID) {
      const imageFile = _.get(this.props, 'modal.openParams.imageFile')
      this.props.modalActions.showModal(IMAGE_EDIT_MODAL, {
        imageFile,
        replaceImageID: params.imageID,
        action: _.get(this.props, 'modal.openParams.action'),
        imageAspectRatio: _.get(
          this.props,
          'modal.openParams.imageAspectRatio',
        ),
      })
    }
  }

  render() {
    return (
      <PortalImageStoreModal
        params={this.props.modal.openParams}
        onRequestClose={this.handleClose}
      />
    )
  }
}

PortalImageStoreModalWithRedux.propTypes = {
  ...modalPropTypes,
}

export default withReduxModal(PortalImageStoreModalWithRedux)



// WEBPACK FOOTER //
// ./src/components/templates/portal-image-store/PortalImageStoreModalWithRedux.js